<template>
  <div class="descBox boxBg">
    <h1 v-if="title">{{ title }}</h1>
    <h3 v-if="desc" v-html="desc"></h3>

    <div class="iconBox">
      <span v-if="isCodeIcon" class="codeIcon" @click="isShowCode = !isShowCode">
        <img src="../assets/code.png" alt="" /></span>
      <span class="copyIcon" v-clipboard="() => {notify();return code; }"><img src="../assets/copy.png" alt="" /></span>
    </div>
    <div class="code" v-if="code && (isShow||isShowCode)">
      <pre v-highlightjs><code>{{code}}
			</code></pre>
    </div>

    <div :is="componentId"></div>
  </div>
</template>

<script>
import demo1 from "../components/code/demo1";
import demo2 from "../components/code/demo2";
import demo3 from "../components/code/demo3";
import demo4 from "../components/code/demo4";
import demo5 from "../components/code/demo5";
import demo6 from "../components/code/demo6";

export default {
  props: ["title", "desc", "isCodeIcon", "code", "componentId", "isShow"],
  components: { demo1, demo2, demo3, demo4, demo5, demo6 },

  data() {
    return {
      isShowCode: false,
    };
  },
  computed: {},
  methods: {
    notify() {
      this.$toast("Copied to clipboard!");
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.descBox {
  position: relative;
  box-sizing: border-box;
  padding: 10px 30px;
  margin-bottom: 5vh;
  max-width: 70vw;
  min-width: 370px;
}

.copyIcon,
.codeIcon {
  padding-left: 1vw;
  img {
    width: 28px;
    height: 28px;
    display: inline-block;
    object-fit: contain;
    cursor: pointer;
    user-select: none;
  }
}

.code {
  text-align: start;
}

.iconBox {
  position: absolute;
  right: 10px;
  top: 10px;
}
</style>
